import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (params) {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '/api/produce-crafts',
    name: 'GET_STD_CRAFT_LIST',
    manual: false,
  });

  useEffect(() => {
    if (params) {
      let url = `/api/produce-crafts`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [data || [], exec, isRequestSuccessed];
});
